var map = {
	"./arrow.svg": 166,
	"./bet-type.svg": 167,
	"./chat.svg": 92,
	"./close.svg": 168,
	"./coins/coin_lumi.svg": 71,
	"./coins/default-coin.svg": 93,
	"./coins/eth.svg": 94,
	"./crown.svg": 95,
	"./default-avatar.svg": 74,
	"./dice-icon.svg": 96,
	"./en.svg": 187,
	"./facebook.svg": 97,
	"./game1.svg": 188,
	"./game2.svg": 169,
	"./game3.svg": 189,
	"./game4.svg": 190,
	"./icon-logo.svg": 73,
	"./leaderboard.svg": 98,
	"./link.svg": 170,
	"./logo.svg": 45,
	"./logo1.svg": 191,
	"./megabit-icon.svg": 99,
	"./referral.svg": 171,
	"./send-mes.svg": 100,
	"./setting.svg": 172,
	"./strife.svg": 173,
	"./telegram.svg": 101,
	"./tick.svg": 174,
	"./twitter.svg": 102,
	"./user-avt.svg": 103,
	"./warning.svg": 175,
	"./youtube.svg": 104,
	"./zh.svg": 192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91;